const EmployeeJson = [
    {
        ID: 1,
        name: 'Oduyemi Obaloluwa'
    },
    {
        ID: 2,
        name: 'Segun Taiwo'
    },
    {
        ID: 3,
        name: 'Akindele Tunde'
    },
    {
        ID: 4,
        name: 'Bolaji Oladipo'
    },
    {
        ID: 5,
        name: 'Awosope Damilola'
    },
    {
        ID: 6,
        name: 'Dare Olayiwola'
    }
]

export default EmployeeJson